import React from "react";

import { FaClipboardList, FaSearch, FaUndoAlt } from "react-icons/fa";

import {
  ALL_EVENT_LEVELS,
  ALL_EVENT_ORGANIZERS,
  ALL_EVENT_TYPES,
  DATE_FILTER_OPTIONS,
} from "../data/convocationsAdmin.constants";

export default function ConvocationsFiltersBar({
  searchText,
  onSearchChange,

  selectedType,
  onTypeChange,
  typeOptions,

  selectedOrganizer,
  onOrganizerChange,
  organizerOptions,

  selectedLevel,
  onLevelChange,
  levelOptions,

  selectedDateFilter,
  onDateFilterChange,

  onlyWithConvocations,
  onOnlyWithConvocationsChange,

  onReset,
  loading,
}) {
  return (
    <section
      aria-label="Filtres des événements"
      className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5"
    >
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <label className="relative sm:col-span-2 xl:col-span-1">
          <span className="sr-only">Rechercher un événement</span>

          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="search"
            value={searchText}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Titre, lieu, type, organisateur ou niveau…"
            className="h-12 w-full rounded-2xl border border-slate-300 bg-white pl-11 pr-4 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </label>

        <label>
          <span className="sr-only">Filtrer par type</span>

          <select
            value={selectedType}
            onChange={(event) => onTypeChange(event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value={ALL_EVENT_TYPES}>Tous les types</option>

            {typeOptions.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span className="sr-only">Filtrer par organisateur</span>

          <select
            value={selectedOrganizer}
            onChange={(event) => onOrganizerChange(event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value={ALL_EVENT_ORGANIZERS}>Tous les organisateurs</option>

            {organizerOptions.map((organizer) => (
              <option key={organizer} value={organizer}>
                {organizer}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span className="sr-only">Filtrer par niveau</span>

          <select
            value={selectedLevel}
            onChange={(event) => onLevelChange(event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value={ALL_EVENT_LEVELS}>Tous les niveaux</option>

            {levelOptions.map((level) => (
              <option key={level} value={level}>
                {level}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span className="sr-only">Filtrer par période</span>

          <select
            value={selectedDateFilter}
            onChange={(event) => onDateFilterChange(event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            {DATE_FILTER_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <button
          type="button"
          aria-pressed={onlyWithConvocations}
          onClick={() => onOnlyWithConvocationsChange(!onlyWithConvocations)}
          className={`inline-flex h-12 items-center justify-center gap-2 rounded-2xl border px-4 text-sm font-semibold transition ${
            onlyWithConvocations
              ? "border-emerald-200 bg-emerald-50 text-emerald-700 ring-2 ring-emerald-500/10 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300"
              : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          }`}
        >
          <FaClipboardList />

          <span className="whitespace-nowrap">Avec convocations</span>
        </button>

        <button
          type="button"
          onClick={onReset}
          disabled={loading}
          className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          <FaUndoAlt />
          Réinitialiser
        </button>
      </div>
    </section>
  );
}
